import './ccf-up-arrow-icon.module.scss';
import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfUpArrowIconProps extends SvgIconProps {}
/**
 * component used to display up arrow icon
 * @param props - CcfUpArrowIconProps
 * @example - <CcfUpArrowIcon />
 * @returns SVG of up arrow icon
 */
export function CcfUpArrowIcon(props: CcfUpArrowIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_dropUpArrow">
        <path id="Path_25529" data-name="Path 25529" d="M5.254,6.149.179,1.075a.649.649,0,0,1,0-.9.649.649,0,0,1,.9,0L5.851,4.955,10.925.179a.649.649,0,0,1,.9,0,.649.649,0,0,1,0,.9L6.448,6.149a.658.658,0,0,1-.537.179A.96.96,0,0,1,5.254,6.149Z" transform="translate(14 11.164) rotate(180)" />
      </g>
    </SvgIcon>
  );
}

export default CcfUpArrowIcon;
